import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from "../../helper/Axios/axiosHelper";
import logger from "../../utils/logger";

//?  Acción asíncrona: Obtener datos desde una API

export const allCommonData = createAsyncThunk(
    "Common/allCommonData", //?👉 Nombre único de la acción
    async (_, { rejectWithValue }) => {
        try {

            const response = await Promise.all([
                apiClient.get('/Common/DocumentTypes'),
                apiClient.get('/Common/CellphonePrefixes'),
                apiClient.get('/Common/Professions'),
                apiClient.get('/Common/FormationPlaces'),
                apiClient.get("/Authentication/Me"),

            ]);

            logger.debug('response redux: ', response)
            const [docTypesRes, cellPrefixesRes, professionsRes, formationRes,AuthMe] = response

            // logger.debug('cellPrefixesRes: ', cellPrefixesRes.data)

            return {
                documentTypes: docTypesRes.data,
                cellphonePrefixes: cellPrefixesRes.data,
                professions: professionsRes.data,
                formationPlaces: formationRes.data,
                myInfo:AuthMe.data
            }

        } catch (error) {
            return rejectWithValue("Error al obtener los usuarios"); // ❌ Envía un mensaje de error a Redux
        }
    }

)


//?{ rejectWithValue } → Se usa para capturar y enviar errores a Redux de forma controlada. Envía el error a action.payload
//? 📢 Así evitamos que la aplicación se rompa y podemos manejar errores en la UI de forma más clara.


const commonDataSlice = createSlice({
    name: "commonData",
    initialState: {
        lista: [],
        estado: "idle",
        error: null
    },


    //?  "extraReducers"  permite manejar las tres fases de la acción asíncrona (pending, fulfilled, rejected)
    //?  "builder" nos permite agregar múltiples casos de acciones de manera encadenada usando .addCase()

    extraReducers: (builder) => {
        builder
            // 👉 Estado de carga
            .addCase(allCommonData.pending, (state) => {
                state.estado = "loading";
            })
            // ✅ Cuando la petición es exitosa
            .addCase(allCommonData.fulfilled, (state, action) => {
                state.estado = "succeeded";
                state.lista = action.payload; // Guardamos los datos del payload
            })
            //👉 Cuando hay un error
            .addCase(allCommonData.rejected, (state, action) => {
                state.estado = "failed";
                state.error = action.payload; //? si existe un error lo recibe action.payload
            });
    }
})

export default commonDataSlice.reducer;
